import {
  faxmarkclassicregular,
  FontAwesomeIcon,
  IconProp
} from '@grc/ui-package';
import { useI18nState } from '../../../../stores/settings/language-context';
import { useCarrierPortalGlobalStore } from '../../../../stores/carrier-portal-global-store';

export default function SettingsMenu({ setIsSettingsDrawerOpened }: any) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [changeLanguage, setChangeLanguage] = useCarrierPortalGlobalStore(
    store => store.store.selectedLanguage
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [changeTheme, setChangeTheme] = useCarrierPortalGlobalStore(
    store => store.store.selectedTheme
  );
  const { localeData } = useI18nState();
  return (
    <div className="themes-language-settings-menu p-3">
      <div className="menu-setting-header d-flex justify-content-between">
        <div className="settings-menu-head">
          <span className="settings-title">{localeData.TemplateCustomize}</span>
          <span className="settings-sun-title">
            {localeData.Customizeandpreview}
          </span>
        </div>
        <div
          onClick={() => {
            setIsSettingsDrawerOpened((prevState: boolean) => !prevState);
          }}
        >
          <FontAwesomeIcon
            icon={faxmarkclassicregular as IconProp}
            fontSize={20}
            className="cursor-p"
          />
        </div>
      </div>

      <div className="themes-section d-flex flex-column">
        <div className="theme-title">{localeData.ThemeStyle}</div>
        <div className="theme-color-options">
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeTheme('light');
            }}
          >
            <div className="theme-color">
              <img
                className="cursor-p"
                src="../assets/svg/theme-light.svg"
                alt=""
              />
            </div>
            <div className="theme-color-name text-center">
              {localeData.Light}
            </div>
          </div>
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeTheme('dark');
            }}
          >
            <div className="theme-color">
              <img
                className="cursor-p"
                src="../assets/svg/theme-dark.svg"
                alt=""
              />
            </div>
            <div className="theme-color-name text-center">
              {localeData.Dark}
            </div>
          </div>
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeTheme('green');
            }}
          >
            <div className="theme-color">
              <span className="color-dark-green"></span>
            </div>
            <div className="theme-color-name text-center">
              {localeData.DarkGreen}
            </div>
          </div>
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeTheme('green');
            }}
          >
            <div className="theme-color">
              <span className="color-dark-green"></span>
            </div>
            <div className="theme-color-name text-center">
              {localeData.TurkishAqua}
            </div>
          </div>
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeTheme('blue');
            }}
          >
            <div className="theme-color">
              <span className="color-dark-green"></span>
            </div>
            <div className="theme-color-name text-center">
              {localeData.Blue}
            </div>
          </div>
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeTheme('blue');
            }}
          >
            <div className="theme-color">
              <span className="color-dark-green"></span>
            </div>
            <div className="theme-color-name text-center">
              {localeData.SoothingBreeze}
            </div>
          </div>
        </div>
      </div>
      <hr></hr>
      <div className="themes-section d-flex flex-column">
        <div className="theme-title">{localeData.Languages}</div>
        <div className="theme-color-options">
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeLanguage('en');
            }}
          >
            <div className="theme-color">
              <img
                className="cursor-p"
                src="../assets/svg/united-states.svg"
                alt=""
              />
            </div>
            <div className="theme-color-name text-center">
              {localeData.UnitedStates}
            </div>
          </div>
          <div
            className="theme-title cursor-p"
            onClick={() => {
              setChangeLanguage('es');
            }}
          >
            <div className="theme-color">
              <img className="cursor-p" src="../assets/svg/spain.svg" alt="" />
            </div>
            <div className="theme-color-name text-center">
              {localeData.Spanish}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
